/**
 * ─── POS Entity Hooks ────────────────────────────────────────
 * Lifecycle hooks for POS entities.
 *
 * - beforeCreate: auto-generate codes, compute derived fields
 * - afterCreate: log stock changes
 * - beforeUpdate: validate state transitions
 */

import type { HookContext, EntityId } from '@repo/core'

export const POSProductHooks = {
  async beforeCreate(input: Record<string, unknown>, ctx: HookContext): Promise<Record<string, unknown>> {
    const d = { ...input }
    // Auto-compute markup if not provided
    if (d.costPrice !== undefined && d.retailPrice !== undefined && d.markupPercent === undefined) {
      const cp = Number(d.costPrice)
      const rp = Number(d.retailPrice)
      if (cp > 0) {
        d.markupPercent = Math.round(((rp - cp) / cp) * 10000) / 100
      }
    }
    return d
  },

  async beforeUpdate(id: EntityId, input: Record<string, unknown>, ctx: HookContext): Promise<Record<string, unknown>> {
    const d = { ...input }
    if (d.costPrice !== undefined || d.retailPrice !== undefined) {
      const cp = Number(d.costPrice ?? 0)
      const rp = Number(d.retailPrice ?? 0)
      if (cp > 0 && rp > 0) {
        d.markupPercent = Math.round(((rp - cp) / cp) * 10000) / 100
      }
    }
    return d
  },
}

export const POSSaleHooks = {
  async beforeCreate(input: Record<string, unknown>, ctx: HookContext): Promise<Record<string, unknown>> {
    const d = { ...input }
    if (!d.saleDate) {
      d.saleDate = new Date().toISOString().slice(0, 10)
    }
    if (!d.saleTime) {
      d.saleTime = new Date().toTimeString().slice(0, 8)
    }
    return d
  },
}

export const POSShiftHooks = {
  async beforeUpdate(id: EntityId, input: Record<string, unknown>, ctx: HookContext): Promise<Record<string, unknown>> {
    const d = { ...input }
    if (d.status === 'closed' && !d.closeTime) {
      d.closeTime = new Date().toTimeString().slice(0, 8)
    }
    return d
  },
}
